// src/components/Breadcrumbs.tsx
import React from "react";
import { Link } from "react-router-dom";

interface BreadcrumbsProps {
  countryId: number;
  countryName: string;
  dealerName: string;
}


const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ countryId, countryName, dealerName }) => {
  return (
    <nav aria-label="breadcrumb" style={{ margin: "20px 0", fontSize: "14px" }}>
      <Link to="/" style={{ textDecoration: "none", color: "#e41e26", fontWeight: "bold" }}>
        Home
      </Link>
      {countryName && (
        <>
          {" / "}
          <Link
			  to={`/country/${countryId}`}
			  style={{ textDecoration: "none", color: "#e41e26", fontWeight: "bold" }}
			>
			  {countryName}
		  </Link>

        </>
      )}
      {dealerName && (
        <>
          {" / "}
          <span style={{ color: "#e41e26", fontWeight: "bold" }}>{dealerName}</span>
        </>
      )}
    </nav>
  );
};

export default Breadcrumbs;
